// app/javascript/controllers/mobile_menu_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  
  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
  }
  
  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }
  
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (!this.hasMenuTarget) {
      return
    }
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }
  
  show() {
    this.menuTarget.classList.remove("hidden")
    this.animateIcon(true)
    
    setTimeout(() => {
      document.addEventListener("click", this.boundClickOutside)
    }, 0)
    
    // Prevent body scroll on mobile
    document.body.style.overflow = "hidden"
  }
  
  hide() {
    this.menuTarget.classList.add("hidden")
    this.animateIcon(false)
    document.removeEventListener("click", this.boundClickOutside)
    document.body.style.overflow = ""
  }
  
  clickOutside(event) {
    if (!this.element.contains(event.target) && 
        !this.menuTarget.contains(event.target)) {
      this.hide()
    }
  }
  
  animateIcon(isOpen) {
    const button = this.element.querySelector("button[data-action*='mobile-menu#toggle']")
    const icon = button?.querySelector("svg")
    
    if (icon) {
      if (isOpen) {
        // Change to X icon
        icon.innerHTML = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>`
      } else {
        // Change back to hamburger icon
        icon.innerHTML = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>`
      }
    }
  }
}